import {FC} from 'react';
import {Layout} from 'antd';
import cn from 'classnames';
import {useAppStore} from '@/stores';
import Logo from './Logo';
import Menu from './Menu';
import s from './index.module.scss';

const {Sider} = Layout;

const SiderMenu: FC = () => {
  const {sidebarCollapsed, mobileSidebarOpen, toggleMobileSidebar} =
    useAppStore();
  return (
    <Sider
      theme='light'
      trigger={null}
      collapsible
      collapsed={sidebarCollapsed}
      className={cn(s.sider, {
        [s.siderOpen]: mobileSidebarOpen,
      })}
    >
      {mobileSidebarOpen && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div className={s.fade} onClick={toggleMobileSidebar}/>
      )}
      <div
        className={cn(s.innerSideWrap, {
          [s.innerSiderWrapCollapsed]: sidebarCollapsed,
        })}
      >
        <Logo collapsed={sidebarCollapsed}/>
        <Menu/>
      </div>
    </Sider>
  );
};

export default SiderMenu;
